var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4555",
    "data-name": "Group 4555",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.787,
    height: 20,
    viewBox: "0 0 22.787 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2703",
    "data-name": "Rectangle 2703",
    width: 22.787,
    height: 18,
    fill: "#4A4A4A"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4550",
    "data-name": "Group 4550",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M217.877,357.2l1.545,2.06a8.085,8.085,0,0,0-2.141,1.067,1.248,1.248,0,1,1-1.406-2.061,10.829,10.829,0,0,1,2-1.066",
    transform: "translate(-210.164 -348.637)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M478.54,331.067a1.246,1.246,0,0,1-1.593.148,8.026,8.026,0,0,0-2.3-1.114l-2.046-2.727h.065a10.108,10.108,0,0,1,5.682,1.78,1.247,1.247,0,0,1,.187,1.913",
    transform: "translate(-461.277 -319.526)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M110.173,232.72l1.488,1.983a12.25,12.25,0,0,0-2.477,1.463,1.192,1.192,0,0,1-1.463-1.881,13.81,13.81,0,0,1,2.452-1.565",
    transform: "translate(-104.7 -227.142)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M377.135,179.323a1.192,1.192,0,0,1-1.567.108,11.369,11.369,0,0,0-6.909-2.4q-.487,0-.951.041l-1.669-2.224a13.341,13.341,0,0,1,10.992,2.7,1.193,1.193,0,0,1,.1,1.773",
    transform: "translate(-357.265 -170.406)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M3.267,110.082,4.709,112a15.048,15.048,0,0,0-2.8,1.838,1.157,1.157,0,0,1-1.563-.071l-.01-.011a1.156,1.156,0,0,1,.06-1.685,16.394,16.394,0,0,1,2.872-1.993",
    transform: "translate(0 -107.443)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M283.8,29.267l-.01.011a1.157,1.157,0,0,1-1.562.071,14.841,14.841,0,0,0-12.914-3.035l-1.545-2.06a16.95,16.95,0,0,1,15.972,3.327,1.155,1.155,0,0,1,.06,1.685",
    transform: "translate(-261.353 -22.95)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M331.426,489.241a3.451,3.451,0,0,0-.445-.029,3.688,3.688,0,0,0-1.733.445,1.246,1.246,0,0,1-1.163-2.2,6.276,6.276,0,0,1,1.546-.6Z",
    transform: "translate(-319.588 -475.18)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M420.362,636.865a1.384,1.384,0,1,1-1.384-1.384,1.384,1.384,0,0,1,1.384,1.384",
    transform: "translate(-407.585 -620.249)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2702",
    "data-name": "Rectangle 2702",
    width: 1.905,
    height: 19.477,
    transform: "matrix(0.8, -0.6, 0.6, 0.8, 3.031, 1.143)",
    fill: "#4A4A4A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.94ed44b1.svg";
export { ForwardRef as ReactComponent };